/**
 * LicBa slice — tracks the active Business Administration (BA) + License (lic)
 * scope for license-related screens. Both IDs are null on initial load and must
 * be set before any license API call is made.
 *
 * Distinct from licenseMgtSlice: this slice holds the *currently viewed* BA/lic
 * context (navigation scope), while licenseMgtSlice carries the in-progress
 * license-creation context (transient workflow state).
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '@/store/rootReducer'

export interface LicBaState {
    baId: number | null
    licId: number | null
}

const initialState: LicBaState = {
    baId: null,
    licId: null,
}

const licBaSlice = createSlice({
    name: 'licBa',
    initialState,
    reducers: {

        setLicBaContext: (
            state,
            action: PayloadAction<{ baId: number; licId: number }>,
        ) => {
            state.baId = action.payload.baId
            state.licId = action.payload.licId
        },
        setBaId: (state, action: PayloadAction<number>) => {
            state.baId = action.payload
        },
        resetLicBaContext: () => initialState,
    },
})

export const { setLicBaContext, setBaId, resetLicBaContext } = licBaSlice.actions

// Fall back to initialState so consumers never receive undefined after a
// hot-reload or SSR rehydration where this key hasn't been populated yet.
export const selectLicBaContext = (state: RootState): LicBaState =>
    state.licBa ?? initialState

export default licBaSlice.reducer
